import React from 'react';
import { Cascader as AntCascader } from 'antd';
import type { CascaderProps } from 'antd';
import clsx from 'clsx';

export const Cascader = ({ className, ...props }: CascaderProps) => (
  <AntCascader {...props} className={clsx('wk-cascader', className)} />
);

Cascader.SHOW_PARENT = AntCascader.SHOW_PARENT;
Cascader.SHOW_CHILD = AntCascader.SHOW_CHILD;
